// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23.9511 21.7H0.0488281L12 1L23.9511 21.7ZM11 15H13V9.5H11V15ZM13.0039 16.5H11V18.5039H13.0039V16.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-error-triangle-filled')
export default class ErrorTriangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'error-triangle-filled',
    }
  }
}
